import { render, staticRenderFns } from "./QiuckRegistration.vue?vue&type=template&id=a4a69654&scoped=true"
import script from "./QiuckRegistration.vue?vue&type=script&lang=js"
export * from "./QiuckRegistration.vue?vue&type=script&lang=js"
import style0 from "./QiuckRegistration.vue?vue&type=style&index=0&id=a4a69654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a69654",
  null
  
)

export default component.exports